import { Box, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next';

export const TermsAndConditions = ({ termsAndConditionsData }) => {
  const { t } = useTranslation();


  const getProcessedContent = (data) => {
    if (!data) return null;

    if (/<[a-z][\s\S]*>/i.test(data)) {
      return data;
    }

    return data.replace(/\n/g, '<br />');
  };
  const processedContent = getProcessedContent(termsAndConditionsData);

  return (
    <div className="applicantDetailsCard">
      <h3 className="titlePersonalHD marginBottom28">
        {t("termsAndConditions.title")}
      </h3>
      {processedContent ? (
        <Box
          id="terms-description"
          dangerouslySetInnerHTML={{ __html: processedContent }}

        />
      ) : (
        <Typography id="terms-description" variant="body2" sx={{ fontWeight: 500 }}>
          {t("termsAndConditions.noTermsAndConditions")}

        </Typography>
      )}
    </div>

  )
}
